import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationHistoryService } from '../../navigation-history.service';
import { AppSettings } from '../../app.settings';
import { Settings } from '../../app.settings.model';

@Injectable()
export class PagesFilterStorageService {

    public settings: Settings;

    constructor(
        public appSettings: AppSettings,
        private navigationService: NavigationHistoryService
    ) {
        this.settings = this.appSettings.settings;
    }

    /**
     * Verifica se é necessário carregar os filtros ou não a partir das rotas.
     * @param pageRoute Rota da página que está solicitando ao serviço.
     */
    public needLoadFilters(pageRoute: Router): boolean {
        if (this.settings.configs.saveFilterInSession) {
            const routeArray = pageRoute.url.split('/');
            const historyRouteArray = this.navigationService.getPreviousUrl().split('/');

            if (historyRouteArray.find(route => route === routeArray[routeArray.length - 1].trim())) {
                return true;
            }
            this._deleteSession((routeArray[routeArray.length - 1].trim()).replace('-', '') + 'Filter');
        }
        return false;
    }

    /**
     * Retorna um objeto de filtro se necessário, ou um void caso não seja necessário.
     * @param pageRoute Rota da página que está solicitando ao serviço.
     */
    public manageFilters(pageRoute: Router): string | void {
        if (this.settings.configs.saveFilterInSession) {
            const routeArray = pageRoute.url.split('/');

            const currentRoute = (routeArray[routeArray.length - 1].trim()).replace('-', '');
            const currentSession = currentRoute + 'Filter';

            if (this.needLoadFilters(pageRoute)) {
                return this.loadSession(currentSession) ? this.loadSession(currentSession) : null;
            } else {
                this._deleteSession(currentSession);
            }
        }
    }

    /**
     * Adiciona o objeto de filtro na session.
     * @param sessionStorageName Nome da sessionStorage.
     * @param filterObject Objeto que deseja salvar na session.
     */
    public addSession(pageRoute: Router, filterObject: any): void {
        const routeArray = pageRoute.url.split('/');
        this._addSession((routeArray[routeArray.length - 1].trim()).replace('-', '') + 'Filter', JSON.stringify(filterObject));
    }

    /**
     * Adiciona o objeto de filtro na session.
     * @param sessionStorageName Nome da sessionStorage.
     * @param filterObject String do objeto que deseja salvar na session.
     */
    private _addSession(sessionStorageName: string, filterObject: string): void {
        sessionStorage.setItem(sessionStorageName, filterObject);
    }

    /**
     * Remove o filtro da session de acordo com a rota enviada por parâmetro.
     * @param pageRoute Rota da página que está solicitando ao serviço.
     */
    public deleteSession(pageRoute: Router): void {
        const routeArray = pageRoute.url.split('/');
        this._deleteSession((routeArray[routeArray.length - 1].trim()).replace('-', '') + 'Filter');
    }

    /**
     * Remove a sessionStorage enviada por parâmetro.
     * @param sessionStorageName Nome da sessionStorage.
     */
    private _deleteSession(sessionStorageName: string): void {
        sessionStorage.removeItem(sessionStorageName);
    }

    /**
     * Retorna a sessionStorage solicitada por parâmetro.
     * @param sessionStorageName Nome da sessionStorage.
     */
    private loadSession(sessionStorageName: string): string {
        return sessionStorage.getItem(sessionStorageName);
    }
}
